module.exports = __webpack_public_path__ + "static/img/menuRysuj-ON.e6ad006c.png";